import { Component, Container, Entity2D } from '../../odie';

import { RocketAnimation } from '../animations/RocketAnimation';
import { DirectionId } from '../defs/block';
import { blockPositionView, blockUpdateDirection } from '../util/blockTools';

// types
//-----------------------------------------------------------------------------
export type RocketComponentOptions = {
  direction: DirectionId;
  big?: boolean;
};

/*
    rocket component
*/
export class RocketComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'rocket';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // state
  private _direction!: DirectionId;
  private _big!: boolean;
  // scene
  public view!: RocketAnimation;

  // properties
  //-------------------------------------------------------------------------
  // direction
  public get direction(): DirectionId {
    return this._direction;
  }

  // init
  //-------------------------------------------------------------------------
  public static assets(): string[] {
    // return RocketAnimation.assets();
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: RocketComponentOptions): void {
    // set direction
    this._direction = options.direction;
    this._big = options.big ?? false;

    // create view
    this.view = new RocketAnimation();
    blockPositionView(this.view, { width: 0, height: 0 });

    // update sprite direction
    blockUpdateDirection(this.view, options.direction);
  }

  public start() {
    // start animation
    this.view.start(this._big);
  }

  public stop() {
    // stop animation
    this.view.stop();
  }
}
